import LoginLayout from "../../layout/login"

// 登录注册模块
export default {
    path: "/login",
    component: LoginLayout,
    redirect: "/login",
    alwaysShow: true,
    name: "Auth",
    children: [
        {
            path: "/login",
            name: "login",
            meta: {
                module: "login",
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				}
            },
            component: () => import("@/views/auth/login")
        },
        {
            path: "/register",
            name: "register",
            meta: {
                module: "login",
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				}
            },
            component: () => import("@/views/auth/register/index.vue")
        },
        {
            path: "hlrjRegister",
            name: "hlrjRegister",
            meta: {
                module: "login",
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				}
            },
            component: () => import("@/views/auth/register/index1.vue")
        },
        {
            path: "/Agreement",
            name: "Agreement",
            meta: {
                module: "login",
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				}
            },
            component: () => import("@/views/auth/Agreement")
        }
    ]
}
